import React from "react";
import { FaLocationDot } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { FiChevronUp } from "react-icons/fi";

function Footer() {
  const gifSrc = "/images/logo/mosa-animated-green.gif";

  function linkRedirect(index) {
    switch (index) {
      case 0:
        return "/";
      case 1:
        return "/apropos";
      case 2:
        return "/metier";
      case 3:
        return "/references";
      case 4:
        return "/contact";
      default:
        console.log("redirection error");
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="bg-[#007E79] text-white p-8 relative shadow-2xl">
      <div className="container mx-auto text-center relative">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
          <div className="flex flex-col lg:flex-row items-center lg:items-start lg:justify-start">
            <div className="w-32 lg:w-56 mb-4 lg:mb-0">
              <img src={gifSrc} alt="GIF" className="w-full" />
            </div>
            <div className="flex flex-col justify-center lg:justify-evenly items-center">
              <h1 className="text-2xl lg:text-4xl font-bold">
                MOSA Ingénierie
              </h1>
              <div className="flex items-center my-2">
                <FaLocationDot className="text-xl lg:text-2xl" />
                <div className="flex flex-col text-left pl-2">
                  <p>5 Chemin du Cluzel</p>
                  <p>69200 Vénissieux</p>
                </div>
              </div>
              <div className="flex items-center my-2">
                <IoMdMail className="text-xl lg:text-2xl" />
                <div className="flex flex-col text-left pl-2">
                  <p>Contact@mosa-ing.fr</p>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t lg:border-t-0 lg:border-l flex flex-col lg:flex-row justify-evenly items-center col-span-2 pt-4 lg:pt-0">
            <div className="flex flex-col lg:flex-row lg:justify-evenly w-full">
              <ul className="flex flex-col justify-center items-center lg:items-start lg:mt-4 lg:mr-8">
                {[
                  "Accueil",
                  "Qui sommes nous ?",
                  "Nos métiers",
                  "Nos références",
                  "Nous contacter",
                ].map((text, index) => (
                  <li className="py-2 px-4" key={index}>
                    <a
                      href={linkRedirect(index)}
                      className="py-1 border-b-2 ease-in-out border-white"
                    >
                      {text}
                    </a>
                  </li>
                ))}
              </ul>
              <div className="flex flex-col justify-center items-center lg:items-start mt-4 lg:mt-0">
                <h3 className="text-sm lg:text-md py-2">
                  Copyright © 2024 MOSA Ingénierie. Tous droits réservés.
                </h3>
                <h3 className="text-sm lg:text-md py-2">
                  <a
                    href="/politique-de-confidentialite"
                    className="py-1 hover:border-b-2 border-white"
                  >
                    Politique de confidentialité
                  </a>{" "}
                  |{" "}
                  <a
                    href="/conditions-generales-utilisation"
                    className="py-1 hover:border-b-2 border-white"
                  >
                    Conditions générales d'utilisation
                  </a>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        className="absolute top-4 right-4 bg-white text-[#007E79] p-2 rounded-full transform shadow-md focus:outline-none transition-transform duration-300 hover:scale-110"
        onClick={scrollToTop}
      >
        <FiChevronUp className="w-6 h-6 animate-pulse" />
      </button>
    </footer>
  );
}

export default Footer;
